import { render, staticRenderFns } from "./DeliveryDetailHeader.vue?vue&type=template&id=7c5f56d9&"
import script from "./DeliveryDetailHeader.vue?vue&type=script&lang=js&"
export * from "./DeliveryDetailHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports